import React, { createContext, useContext, useEffect, useState } from "react";
import { getToken, me, clearToken } from "@/lib/adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, admin: null });

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setState({ loading: false, admin: null });
      return;
    }
    me()
      .then((admin) => setState({ loading: false, admin }))
      .catch(() => {
        clearToken();
        setState({ loading: false, admin: null });
      });
  }, []);

  const setAdmin = (admin) => setState({ loading: false, admin });
  const logout = () => {
    clearToken();
    setState({ loading: false, admin: null });
  };

  return (
    <AdminAuthContext.Provider value={{ ...state, setAdmin, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
}
